import { Link } from 'gatsby'
import styled, { css } from 'styled-components'
import { ifProp } from 'styled-tools'

import { Container as BaseContainer } from 'components/layout/grid'
import Logo from 'images/inlineSVG/happitu-logo.svg'
import theme from 'themes'
import { defaultButtonStyle } from 'themes/GlobalStyle'
import getStyle from 'themes/getStyle'

export const Container = styled(BaseContainer)<{ showBackground: boolean }>`
  background: ${getStyle('siteBackground')};
  padding: 1em 1.5em;
  border-bottom: 1px solid transparent;
  transition: border-color 150ms, box-shadow 200ms;
  box-shadow: 0, 0, 0 rgba(0, 0, 0, 0);
  margin: 0;

  ${ifProp(
    'isFloating',
    css`
      box-shadow: ${getStyle('siteShallowBoxShadow')};
      border-color: ${getStyle('siteBorderColor')};
    `,
  )}
`

export const NavLink = styled(Link)`
  background: transparent;
  border: 0;
  padding: 0.25em;
  color: ${getStyle('navLinkColor')};
  font-weight: 600;
  font-size: 16px;
  line-height: 1rem;
  display: inline-block;
  text-align: center;

  @media screen and (max-width: 768px) {
    padding: 0.5em 1.5em;
    font-size: 20px;
  }
`

export const LoginButton = styled.a`
  ${defaultButtonStyle}
  font-weight: 600;
  padding: 0.5em 0.75em;

  @media screen and (max-width: 1023px) {
    display: none;
  }
`

export const HappituLogo = styled(Logo)`
  margin-left: 1px;
  width: 110px;

  .happitu-logo {
    fill: ${getStyle('siteColor')};
  }

  @media screen and (max-width: 768px) {
    transform: translateY(2px);
    width: 80px;
  }
`

export const Wrapper = styled.nav<{ isFloating: boolean }>`
  position: sticky;
  top: 0em;
  z-index: ${theme.zIndex.navMenu};
  transition: transform 150ms ease-in-out;
  max-width: ${getStyle('siteWidth')};
  margin: 0 auto;
  width: 100%;
`
